import { TrackJS } from "trackjs";

import {
  TRACK_JS_APPLICATION_KEY,
  TRACK_JS_TOKEN,
} from "helpers/error_reporting/constants";
import { isDevelopment } from "helpers/env";
import "./error_api_interceptor";

const initErrorReporting = (sessionId: string) => {
  if (TrackJS && !TrackJS.isInstalled() && !isDevelopment()) {
    TrackJS.install({
      token: TRACK_JS_TOKEN,
      application: TRACK_JS_APPLICATION_KEY,
      version: APP_GIT_HASH,
    });
    TrackJS.configure({ sessionId });
  }
};

const addMetadata = (key: string, value: string) => {
  if (TrackJS && TrackJS.isInstalled()) {
    TrackJS.addMetadata(key, value);
  }
};

const reportError = (
  error: Error | object | string,
  metadata?: Record<string, string>
) => {
  if (metadata) {
    Object.entries(metadata).forEach(([key, value]) => {
      addMetadata(key, value);
    });
  }
  TrackJS.track(error);
};

export { addMetadata, initErrorReporting, reportError };
